export const BREADCRUMBS_PARTS = {
  home: 'home',
  collection: 'collection',
  category: 'category',
};

export const MAX_RATING_POINTS = 5;

export const CURRENCY_NAME = 'INR';

export const COUNTRY_NAME = 'IN';

export const SCHEMA_TYPE = {
  Product: 'Product',
  ProductGroup: 'ProductGroup',
  Offer: 'Offer',
  Brand: 'Brand',
  Rating: 'Rating',
  Review: 'Review',
  Person: 'Person',
  AggregateRating: 'AggregateRating',
  MerchantReturnPolicy: 'MerchantReturnPolicy',
  LIST_ITEM: 'ListItem',
  BreadcrumbList: 'BreadcrumbList',
};
